import React from "react";
import { Route, Routes } from "react-router-dom";
import { CheckUserPage } from "./CheckUser/checkUser.page";
import { RegisterPage } from "./Register/register.page.jsx";
import LoginPage from "./Login";
import { RecoverPasswordPage } from "./RecoverPass/recoverPassword.page";
import { PostRegPage } from "./PostReg/postReg.page";
import { ConfirmEamailPage } from "./ConfirmEmail/confirmEmail.page";
import SetNewPasswordpage from "./setNewPass";

const AuthRouter = () => {
	return (
		<Routes>
			<Route>
				<Route index element={<CheckUserPage />} />
				<Route path="login" element={<LoginPage />} />
				<Route path="register" element={<RegisterPage />} />
				<Route path="check_mail" element={<ConfirmEamailPage />} />
				<Route path="postreg" element={<PostRegPage />} />
				<Route path="recover" element={<RecoverPasswordPage />} />
				<Route path="set_pass" element={<SetNewPasswordpage />} />
			</Route>
		</Routes>
	);
};

export default AuthRouter;
